import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Textarea } from '@/components/ui/textarea'
import { Loader2 } from 'lucide-react'

export type CanalEnvioManual = 'whatsapp' | 'telefono' | 'persona' | 'otro'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  clienteNombre: string
  isSubmitting: boolean
  onConfirm: (canal: CanalEnvioManual, notas: string) => Promise<void>
}

const CANALES: { value: CanalEnvioManual; label: string }[] = [
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'telefono', label: 'Teléfono' },
  { value: 'persona', label: 'En persona' },
  { value: 'otro', label: 'Otro' },
]

export function MarcarEnvioManualDialog({
  open,
  onOpenChange,
  clienteNombre,
  isSubmitting,
  onConfirm,
}: Props) {
  const [canal, setCanal] = useState<CanalEnvioManual>('whatsapp')
  const [notas, setNotas] = useState('')

  const handleConfirmar = async () => {
    await onConfirm(canal, notas.trim())
    setNotas('')
    setCanal('whatsapp')
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Marcar como enviado manualmente</DialogTitle>
          <DialogDescription>
            Registrá que ya enviaste el estado de cuenta a {clienteNombre} por un canal externo.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="canal-envio">Canal</Label>
            <Select value={canal} onValueChange={(v) => setCanal(v as CanalEnvioManual)}>
              <SelectTrigger id="canal-envio">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {CANALES.map((c) => (
                  <SelectItem key={c.value} value={c.value}>
                    {c.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="notas-envio">Notas (opcional)</Label>
            <Textarea
              id="notas-envio"
              value={notas}
              onChange={(e) => setNotas(e.target.value)}
              placeholder="Ej: le mandé el PDF por WhatsApp el 5/5"
              rows={3}
              maxLength={500}
            />
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button onClick={handleConfirmar} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Registrando...
              </>
            ) : (
              'Confirmar'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
